import { ControlListProps, useTranslation, useTranslations } from "@bsm/component";
import { useCurrenciesQuery } from "hooks/useCurrenciesQuery";
import { ItemsControl } from "../components/ItemsControl";

export const useBankCreateForm = (id?: number): ControlListProps => {
    const [
        SAVE,
        CANCEL
    ] = useTranslations(i18n);
    
    const t = useTranslation()

    const { data: currencies} = useCurrenciesQuery(true)
    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "items",
                    name: "currency",
                    options: currencies.map((item) => ({
                        label: t(item.translationKey as any),
                        value: item.value
                    })),
                    label: "Choose one currency",
                    required: true,
                },
                {
                    type: "input",
                    name: "bankName",
                    label: "Bank name",
                    className: '',
                    placeholder: "Enter bank name",
                    required: true,
                },
                {
                    type: "input",
                    name: "iban",
                    label: "IBAN",
                    className: '',
                    placeholder: "Enter bank iban",
                    required: true,
                },
                {
                    type: "input",
                    name: "bankAdress",
                    label: "Address",
                    className: '',
                    placeholder: "Enter bank address",
                },
            ],
            value: {},
            graphQL: {
                entity: 'bankInformation',
                enableFetch: id !== undefined
            },
            next: {
                label: SAVE,
                className: "btn btn-primary text-white",
            },
            back: {
                label: CANCEL,
            },
            fields: {
                "items": ItemsControl,
            }
        },
        onBeforeSetFormData: (value) => {
            return {
                ...value,
                currency: value.currency,
            };
        },
        id: "bank-form",
    };
}

const i18n = [
    "std_save",
    "std_cancel"
]